<app-navbar title="Kwaterunek">
	<div class="btn btn-danger me-4" *ngIf="service.reservationMove" (click)="reservationMoveCancel()">
		<i class="fas fa-share-square"></i> Anuluj
	</div>
	<!-- <div class="btn btn-light me-4" (click)="productsSelect()"></div> -->
	<div class="btn btn-light me-4" *ngIf="!service.reservationMove" (click)="withOut()">
		Niezakwaterowanych: {{ service.data.withoutRooms.length }}
	</div>

	<div class="btn btn-light me-4" *ngIf="!service.reservationMove" (click)="destinationSelect()">
		{{ (service.selected | async).destination.name }}
	</div>

	<div class="btn btn-light me-4" *ngIf="!service.reservationMove" (click)="productsSelect()">
		Produktów: {{ (service.selected | async).products.length }}
	</div>

	<div class="btn btn-light me-4" *ngIf="!service.reservationMove">
		<mat-slide-toggle [(ngModel)]="service.show.noname" (click)="noNameShow()"> No-Name </mat-slide-toggle>
	</div>
	<div class="btn btn-light me-4" *ngIf="!service.reservationMove">
		<mat-slide-toggle [(ngModel)]="service.show.subrooms"> Podrzędne </mat-slide-toggle>
	</div>
	<a class="btn btn-primary" routerLink="/accommodation-file/generate">
		<i class="far fa-list-alt"></i>
		Generuj
	</a>
</app-navbar>

<div class="mainWindow">
	<app-accommodations-datebar [months]="months"></app-accommodations-datebar>
	<div class="app-accommodations-products">
		<app-accommodations-products [products]="service.data.productsSelected"></app-accommodations-products>
	</div>
	<div class="app-accommodations-noname-margin" *ngIf="service.show.noname"></div>
	<div class="app-accommodations-noname" *ngIf="service.show.noname">
		<app-accommodations-products [products]="service.data.nonames"></app-accommodations-products>
	</div>
	<button type="button" class="btn btn-info" (click)="showLegend = !showLegend">Legenda</button>
</div>

<div id="legend">
	<div class="btn-group" *ngIf="showLegend">
		<button type="button" class="btn" style="background: rgba(255, 51, 255, 0.9); color: #ffffff">
			Dokwaterowania
		</button>
		<button type="button" class="btn" style="background: rgba(255, 255, 0, 0.9)">Name opcja</button>
		<button type="button" class="btn" style="background: rgba(255, 128, 0, 0.9); color: #ffffff">
			Name potwierdzona
		</button>
		<button type="button" class="btn" style="background: rgba(0, 255, 255, 0.9); color: #ffffff">
			No-name opcja
		</button>
		<button type="button" class="btn" style="background: rgba(0, 128, 255, 0.9); color: #ffffff">
			No-name potwierdzona
		</button>
		<button type="button" class="btn" style="background: rgba(191, 255, 0, 0.9); color: #ffffff">
			Objazdówka opcja
		</button>
		<button type="button" class="btn" style="background: rgba(0, 255, 0, 0.9); color: #ffffff">
			Objazdówka potwierdzona
		</button>
	</div>
</div>
